import { useTranslation } from 'react-i18next';

import { useMondiaCustomerPortalUrl } from '../../../../hooks/apiHooks/subscriptionHooks';

interface MondiaBillingInfoProps {
  className?: string;
  expiresAt?: number;
  operatorName?: string | null;
}

const formatExpiry = (
  expiresAt: number | undefined,
  locale: string,
): string | null => {
  if (!expiresAt) return null;
  const ms = expiresAt < 1e12 ? expiresAt * 1000 : expiresAt;
  const d = new Date(ms);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export default function MondiaBillingInfo({
  className = 'text-sm text-white',
  expiresAt,
  operatorName,
}: MondiaBillingInfoProps) {
  const { t, i18n } = useTranslation();
  const { data, isLoading } = useMondiaCustomerPortalUrl(true);
  const url = data?.data.url;
  const expiryLabel = formatExpiry(expiresAt, i18n.language);

  return (
    <div className={className}>
      {expiryLabel && (
        <div className="mb-2">
          {t('account.mondiaActiveUntil', { date: expiryLabel })}
        </div>
      )}
      {t('account.mondiaBillingInfo', { operator: operatorName || 'Mondia' })}{' '}
      {isLoading || !url ? (
        <span className="underline opacity-50">{t('account.goHere')}</span>
      ) : (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="underline">
          {t('account.goHere')}
        </a>
      )}
      .
    </div>
  );
}
